<template lang="pug">
.wrapper
    .main-container
        HeaderGlobal(v-if="isKey" :HeaderGlobalHeading="`Search '${ keyword }'`" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        HeaderGlobal(v-else HeaderGlobalHeading="No keyword found!" :HeaderGlobalBreadcrumb="breadcrumb").py-4
        .box
            //- .box__header.no-border
            //-         header.flex.items-center.justify-between
            //-             .header-meta
            //-                 h2.subheading Search Result
            //-             //- .header-cta
                            span Found {{ search_by_name.total_data ? search_by_name.total_data : 0 }} data
            .box__body
                .box-tabs(class="lg:pt-4 pt-0")
                    vue-tabs(@tab-change="handleTabChange" ref="tabsRef")
                        v-tab(title="Identity Data")
                            .flex.items-start.flex-wrap
                                .block.sidebar-filter-name(
                                    class="lg:w-2/12 w-full"
                                    v-bind:class="{'is-show' : filterShow}"
                                    )
                                    .mobile-only
                                        .header-filter.mb-4.flex.items-center.justify-between
                                            h2 Filter
                                            button.btn-icon.btn-icon-40(
                                                v-on:click="filterShow = !filterShow"
                                            )
                                                .icon-btn
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                    .mb-3.w-full
                                        label.block.text-sm.font-bold.mb-2(for="fieldSelect") Province
                                        .relative
                                            .flex.flex-wrap.items-center.justify-center.p-2.absolute.w-full.bg-black.z-40(v-if="loading_province === true")
                                                Spinner(show="true" size="24")
                                            select.field-style(v-model="province")
                                                //- option
                                                option(value="") All
                                                //- template(v-if="provinces.length > 0")
                                                    option(v-for="province in provinces" :value="province") {{ province }}
                                                template(v-if="search_by_name_filter_province.data && search_by_name_filter_province.data.length > 0")
                                                    option(v-for="province in search_by_name_filter_province.data" :value="province.id + '_' + province.name") {{ province.name }}

                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>

                                    .mb-3.w-full
                                        label.block.text-sm.font-bold.mb-2(for="fieldSelect") City
                                        .relative
                                            .flex.flex-wrap.items-center.justify-center.p-2.absolute.w-full.bg-black.z-40(v-if="loading_city === true")
                                                Spinner(show="true" size="24")
                                            select.field-style(v-model="city")
                                                option(value="") All
                                                //- template(v-if="cities.length > 0")
                                                    option(v-for="city in cities" :value="city") {{ city }}
                                                template(v-if="search_by_name_filter_city.data && search_by_name_filter_city.data.length > 0")
                                                    option(v-for="city in search_by_name_filter_city.data" :value="city.id + '_' + city.name") {{ city.name }}

                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                    .mb-3.w-full
                                        label.block.text-sm.font-bold.mb-2(for="fieldSelect") District
                                        .relative
                                            .flex.flex-wrap.items-center.justify-center.p-2.absolute.w-full.bg-black.z-40(v-if="loading_district === true")
                                                Spinner(show="true" size="24")
                                            select.field-style(v-model="district")
                                                option(value="") All
                                                //- template(v-if="districts.length > 0")
                                                    option(v-for="district in districts" :value="district") {{ district }}
                                                template(v-if="search_by_name_filter_district.data && search_by_name_filter_district.data.length > 0")
                                                    option(v-for="district in search_by_name_filter_district.data" :value="district.name") {{ district.name }}
                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                
                                    .mb-3.w-full
                                        label.block.text-sm.font-bold.mb-2(for="fieldSelect") Gender
                                        .relative
                                            select.field-style(v-model="gender")
                                                option(value="") All
                                                //- template(v-if="search_by_name.data && search_by_name.data.length > 0")
                                                option(v-for="(gender,index) in filter_gender" :value="gender") {{ gender }}
                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                    .mb-3.w-full
                                        label.block.text-sm.font-bold.mb-2(for="fieldSelect") Year Of Birth
                                        .relative
                                            select.field-style(v-model="year_of_birth")
                                                option(value="") All
                                                template(v-if="year_of_birth_options.length > 0")
                                                    option(v-for="year in year_of_birth_options" :value="year") {{ year }}
                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                    .mb-3.w-full
                                        label.block.text-sm.font-bold.mb-2(for="fieldSelect") Age Range
                                        .flex
                                            input.field-style(type="number" placeholder="Min Age" min="0" v-model="age_min")
                                            span.w-4
                                            input.field-style(type="number" placeholder="Max Age" min="0" v-model="age_max")

                                    .flex
                                        button.btn.btn-primary.flex-grow(type='button' @click="getData(true)") Filter
                                        button.btn.btn-default.flex-grow(type='button' @click="reset()") Reset

                                        //- .relative
                                            select.field-style(v-model="year_of_birth")
                                                option(value="") All
                                                template(v-if="year_of_birth_options.length > 0")
                                                    option(v-for="year in year_of_birth_options" :value="year") {{ year }}
                                            .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                            
                                .block(class="lg:w-10/12 lg:pl-8 p-0 w-full")
                                    .block(class="lg:py-4 p-4")
                                        .filter-info.text-light.flex.items-center.justify-between.mb-4
                                            //- .flex(class="lg:flex-row flex-col")
                                                p(style="padding-right:4px") Showing data from 
                                                span Jawa Barat, Kota Bandung
                                            .mobile-only
                                                button.btn-primary-o(
                                                    type='button'
                                                    v-on:click="filterShow = !filterShow"
                                                ) Change Filter
                                        .flex.items-center.justify-between
                                            .field.mr-2.relative.field--search
                                                span Found {{ search_by_name.total_data ? search_by_name.total_data : 0 }} data
                                            .flex.flex-wrap.items-center
                                                span.mr-2.m-hide Show
                                                .field.relative
                                                    select.field-style#filter-record-size(@change="sizeChange($event)" v-model="items_per_page" style="min-width:80px")
                                                        option(v-for="(s,index) in size" :key="index" :value="s") {{ s }}
                                                    .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                                                span.ml-2.m-hide entries

                                    .table-static.w-full
                                        table
                                            thead
                                                tr
                                                    th(v-for="(th, index) in tableThead" :key="index")
                                                        | {{ th.name }}
                                            tbody
                                                tr(v-if="load_data_status_search_by_name === 'loading'")
                                                    td.text-center(:colspan="tableThead.length")
                                                        .flex.flex-wrap.items-center.justify-center
                                                            Spinner(show="true" size="48")

                                                template(v-else-if="search_by_name.data && search_by_name.data.length > 0")
                                                    tr(v-for="(data, index) in search_by_name.data" :key="index")
                                                        td
                                                            router-link.flex.items-center(:to="data._source.nik ? '/result/'+ encryptNik(data._source.nik) +'/profile' : '/result/profile'" target="_blank" v-tooltip="data._source.nama && data._source.nama.length > 11? data._source.nama : ''")
                                                                //- figure.w-12.h-12.mr-4
                                                                    img.w-full.h-full.object-cover.rounded-full.bg-gray-100(src="https://randomuser.me/api/portraits/women/50.jpg")

                                                                .link-text.whitespace-no-wrap {{ data._source.nama ? data._source.nama : '-' }}    

                                                                //- .link-text {{ data._source.nama ? (data._source.nama.length > 11 ? data._source.nama.substr(0, 11)+'...' : data._source.nama) : '-' }}

                                                        td {{ data._source.jenis_kelamin ? data._source.jenis_kelamin : '-' }}
                                                        td
                                                            .whitespace-no-wrap {{ data._source.tgl_lahir ? data._source.tgl_lahir.substring(0, 10) : '-' }}
                                                        //- td {{ data._source.tgl_lahir ? calculateAge(data._source.tgl_lahir.substring(0, 10)) : '-' }}
                                                        td {{ data._source.age ? data._source.age : '-' }}
                                                        td 
                                                            .text-xs {{ data._source.alamat ? data._source.alamat : '-' }}, {{ data._source.kec ? data._source.kec : '-' }}, {{ data._source.kab ? data._source.kab : '-' }}, {{ data._source.pro ? data._source.pro : '-' }}
                                                        //- td {{ data._source.kec ? data._source.kec : '-' }}
                                                        //- td {{ data._source.kab ? data._source.kab : '-' }}
                                                        //- td {{ data._source.pro ? data._source.pro : '-' }}

                                                tr(v-else)
                                                    td.text-center(:colspan="tableThead.length") No Data Available

                                        .mt-5
                                        vue-ads-pagination(
                                            :total-items="total_data"
                                            :items-per-page="items_per_page"
                                            :page="page"
                                            :max-visible-pages="5"
                                        )
                                            template(slot="buttons" slot-scope="props")
                                                vue-ads-page-button(
                                                    v-for="(button, key) in props.buttons"
                                                    :key="key"
                                                    v-bind="button"
                                                    :class="{'bg-yellow-dark': button.active}"
                                                    @page-change="page = button.page"
                                                    @range-change="start = button.start; end = button.end"
                                                )

                        v-tab(title="Personal Identity")
                            SourcePersonalIdentity
                        
                        v-tab(title="Imigration")
                            SourceTravelHistory

                        v-tab(title="Marketplace")
                            SourceMarketplace
                        
                        v-tab(title="Paspor")
                            SourcePaspor

                        v-tab(title="PLN Data")
                            SourcePln

</template>

<script>
import { mapState } from 'vuex';
import { encrypt,decrypt } from '@/util/crypto';
import HeaderGlobal from './../../components/HeaderGlobal.vue';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';
import {VueTabs, VTab} from 'vue-nav-tabs';
import SourceTravelHistory from './SourceTravelHistory.vue'
import SourcePaspor from './SourcePaspor.vue'
import SourceMarketplace from './SourceMarketplace.vue'
import SourcePersonalIdentity from './SourcePersonalIdentity.vue'
import SourcePln from './SourcePln.vue'

export default {
    name: 'PageName',
    components: {
        HeaderGlobal,
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
        VueTabs,
        VTab,
        SourceTravelHistory,
        SourceMarketplace,
        SourcePersonalIdentity,
        SourcePln,
        SourcePaspor,
    },
    data: function() {
        return {
            breadcrumb: [
                {
                    name: 'Search By Name',
                    url: '/search-by-name',
                },
            ],
            monitoringOnly: false,
            popupShowMonitoring: false,
            filterShow: false,
            dataTarget: [
                {
                    no: 1,
                    name: `Devi Krisdiansyah`,
                    gender: 'laki-laki',
                    address: 'Jl tanjung no.123, nikitakan',
                    district: 'Umbulharjo',
                    city: 'BANDUNG',
                    province: 'JAWA BARAT',
                },
            ],
            tableThead: [
                {
                    name: 'Name',
                    // number: true,
                },{
                    name: 'Gender',
                },{
                    name: 'Birth Date',
                },{
                    name: 'Age',
                },{
                    name: 'Address',
                // },{
                //     name: 'District',
                // },{
                //     name: 'City',
                // },{
                //     name: 'Province',
                },
            ],
            keyword: '',
            data_result: [],

            // pagination
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            // for filter
            gender: '',
            province: '',
            city: '',
            district: '',
            year_of_birth_data: '',
            age_min: '',
            age_max: '',

            loading_province: false,
            loading_city: false,
            loading_district: false,

            // for data select options
            provinces: [],
            cities: [],
            districts: [],

            filter_gender: ['L', 'P'],
            timeout: null,

            first_load_travel_history: true,
            first_load_paspor: true,
            first_load_marketplace: true,
            first_load_university: true,
            first_load_personal_identity: true,
            first_load_pln: true,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_search_by_name',
            'search_by_name',
            'search_by_name_filter_province',
            'search_by_name_filter_city',
            'search_by_name_filter_district',
        ]),
        route_name() {
            return this.$route.name;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            return this.key ? true : false;
        },
        year_of_birth: {
            get() {
                let data = this.year_of_birth_data;
                // if (this.year_of_birth_data === '') {
                //     const finish_year = new Date().getFullYear();
                //     data = finish_year - 16;
                // }

                return data;
            },
            set(v) {
                this.year_of_birth_data = v;
            },
        },
        year_of_birth_options() {
            const start_year = 1900;
            const finish_year = new Date().getFullYear();

            let options = [];
            let count_year = finish_year;

            for (var i = (finish_year + 1); i >= (start_year + 1); i--) {
                options.push(count_year--);
            }

            return options;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageName') {
                if (oldData !== 'PageName') {
                    this.items_per_page = 10;
                    this.page = 0;
                    // this.keyword = '';
                    this.$store.commit('setSearchByName', {});
                }
                // this.getData();
            }
        },
        key() {
            // if (this.route_name === 'PageName')
            this.gender = '';
            this.province = '';
            this.city = '';
            this.district = '';
            // this.year_of_birth_data = '';
            this.year_of_birth = '';
            this.age_min = '';
            this.age_max = '';

            // this.page = 0;
            this.getData(true);

            this.changeDefaultTab(0);
            this.first_load_travel_history = true;
            this.first_load_paspor = true;
            this.first_load_marketplace = true;
            this.first_load_university = true;
            this.first_load_personal_identity = true;
            this.first_load_pln = true;
        },
        isKey() {},
        breadcrumb() {},

        search_by_name(newData) {
            if (Object.keys(newData).length > 0) {
                this.total_data = parseInt(newData.total_data);
                // this.page = (parseInt(newData.current_page) - 1);
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        // filter
        // search_by_name_filter_province(newData) {
        //     console.log(newData)
        // },
        // search_by_name_filter_city(newData) {
        //     console.log(newData)
        // },
        search_by_name_filter_district() {
            // console.log(newData)
        },
        gender() {
            // this.filterBy();
            // this.getData();
        },
        async province(newData) {
            // this.filterBy();
            this.city = '';
            this.district = '';
            this.$store.commit('setSearchByNameFilter', ['city', {}]);
            this.$store.commit('setSearchByNameFilter', ['district', {}]);
            // this.getData();

            // ----
            if (newData.length > 0 && Object.keys(this.search_by_name_filter_city).length === 0) {
                // this.showLoading(true);
                this.loading_city = true;
                await this.$store.dispatch('getSearchByNameFilter', ['city', newData.split('_')[0]])
                .then(() => {
                    // this.showLoading(false);
                    this.loading_city = false;
                });
            }
        },
        async city(newData) {
            // this.filterBy();
            this.district = '';
            this.$store.commit('setSearchByNameFilter', ['district', {}]);
            // this.getData();

            // ----
            if (newData.length > 0 && Object.keys(this.search_by_name_filter_district).length === 0) {
                // this.showLoading(true);
                this.loading_district = true;
                await this.$store.dispatch('getSearchByNameFilter', ['district', newData.split('_')[0]])
                .then(() => {
                    // this.showLoading(false);
                    this.loading_district = false;
                });
            }
        },
        district() {
            // this.filterBy();
            // this.getData();
        },
        year_of_birth() {
            // this.filterBy();
            // this.getData();
        },
        age_min() {
            // if (newData.length !== 0 && this.age_max.length !== 0) {
                // clearTimeout(this.timeout);
            
                // var self = this;
                // this.timeout = setTimeout(function () {
                //     self.getData();
                // }, 650);
            // }
        },
        age_max() {
            // if (newData.length !== 0 && this.age_min.length !== 0) {
                // clearTimeout(this.timeout);
            
                // var self = this;
                // this.timeout = setTimeout(function () {
                //     self.getData();
                // }, 650);
            // }
        },
    },
    methods: {
        handleTabChange(index, newTab) { // index, newTab, oldTab
            if (index === 2 && newTab.title.toLowerCase() === 'imigration' && this.first_load_travel_history === true) {
                EventEmit.$emit('openSearchByNameTravelHistory');
                this.first_load_travel_history = false;
            }

            if (index === 4 && newTab.title.toLowerCase() === 'paspor' && this.first_load_paspor === true) {
                EventEmit.$emit('openSearchByNamePaspor');
                this.first_load_paspor = false;
            }

            if (index === 3 && newTab.title.toLowerCase() === 'marketplace' && this.first_load_marketplace === true) {
                EventEmit.$emit('openSearchByNameMarketplace');
                this.first_load_marketplace = false;
            }

            if (index === 4 && newTab.title.toLowerCase() === 'university' && this.first_load_university === true) {
                EventEmit.$emit('openSearchByNameUniversity');
                this.first_load_university = false;
            }

            if (index === 1 && newTab.title.toLowerCase() === 'personal identity' && this.first_load_personal_identity === true) {
                EventEmit.$emit('openSearchByNamePersonalIdentity');
                this.first_load_personal_identity = false;
            }

            if (index === 5 && newTab.title.toLowerCase() === 'pln data' && this.first_load_pln === true) {
                EventEmit.$emit('openSearchByNamePln');
                this.first_load_pln = false;
            }

            console.log('handle tab change')
            console.log([index, newTab.title.toLowerCase()])
        },
        changeDefaultTab(index=null){
            var self = this;
            self.$nextTick(() => {
                // if (self.tabActive != null && typeof(self.$refs.tabsRef) !== 'undefined') {
                //     self.$refs.tabsRef.navigateToTab(self.tabActive);
                //     this.setTabActive(null);
                // } else if(index != null){
                //     self.$refs.tabsRef.navigateToTab(index);
                // }
                if(index != null)
                    self.$refs.tabsRef.navigateToTab(index);
            });
        },
        encryptNik(nik) {
            return encrypt(nik + '&&nik');
        },
        calculateAge(dob) {

            dob = dob.split('-');
            let date = new Date(parseInt(dob[0]), (parseInt(dob[1]) - 1), parseInt(dob[2]));
            
            var diff_ms = new Date() - date.getTime();
            var age_dt = Math.floor(diff_ms / (1000 * 60 * 60 * 24 * 365.2425));

            return age_dt;
        },
        async getData(filter=false) {
            // console.log('getData++++++++++')
            if (this.route_name === 'PageName' ) {
                if (this.isKey) {

                    if (filter)
                        this.page = 0;

                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');

                    var key = decrypt_data[0];
                    // var type = decrypt_data[1];

                    this.keyword = key;

                    // gender='', province='', city='', district='', year_of_birth='', age_range=''

                    await this.$store.dispatch('getSearchByName', [key, this.items_per_page, (this.page + 1), this.gender, (this.province.length > 0 ? this.province.split('_')[1] : ''), (this.city.length > 0 ? this.city.split('_')[1] : ''), this.district, this.year_of_birth, (this.age_min.length > 0 && this.age_max.length > 0 ? this.age_min + '-' + this.age_max : '')]);

                    // get filter params
                    if (Object.keys(this.search_by_name_filter_province).length === 0) {
                        // this.showLoading(true);
                        this.loading_province = true;
                        await this.$store.dispatch('getSearchByNameFilter', ['province'])
                        .then(() => {
                            // this.showLoading(false);
                            this.loading_province = false;
                        });
                    }

                    // if (this.province.length > 0 && Object.keys(this.search_by_name_filter_city).length === 0) {
                    //     this.showLoading(true);
                    //     await this.$store.dispatch('getSearchByNameFilter', ['city', this.province.split('_')[0]])
                    //     .then(() => {
                    //         this.showLoading(false);
                    //     });
                    // }

                    // if (this.city.length > 0 && Object.keys(this.search_by_name_filter_district).length === 0) {
                    //     this.showLoading(true);
                    //     await this.$store.dispatch('getSearchByNameFilter', ['district', this.city.split('_')[0]])
                    //     .then(() => {
                    //         this.showLoading(false);
                    //     });
                    // }
                
                    this.pagination();
                    
                } else {
                    this.$store.commit('setSearchByName', []);
                }                
            }
        },
        getFilterData(type, id=null) {
            // let type_title_case = type.charAt(0).toUpperCase() + type.slice(1);

            console.log(type)
            console.log(id)



            // this.getData();
        },
        reset() {

            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset?',
                // text: 'Role : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');
                if (result.isConfirmed) {
                    this.gender = '';
                    this.province = '';
                    this.city = '';
                    this.district = '';
                    // this.year_of_birth_data = '';
                    this.year_of_birth = '';
                    this.age_min = '';
                    this.age_max = '';

                    this.getData(true);
                }
            });

        },
        // pagination
        pageChange(page) {
            this.page = page;
        },
        rangeChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
    },
    mounted() {
        this.getData();
    },
}
</script>

<style lang="sass">
    .sidebar-filter-name
        label
            font-size: 9px
            text-transform: uppercase
        font-size: 11px
    @media screen and (max-width: 480px)
        .sidebar-filter-name
            position: fixed
            width: 100vw
            height: 100vh
            overflow: auto
            top: 0
            right: 0
            bottom: 0
            left: 0
            background-color: $color-bg
            z-index: 1001
            padding: 16px
            font-size: 1em
            display: none
            label
                font-size: 0.75em
            button.btn
                height: 48px
            &.is-show
                display: block
</style> 
